import { ContainerModule } from 'inversify';
import { DIUploadTypes } from '@/dataroom/app/DI/FileUpload/types';
import UsersUploadDispatcherFactory from '@/dataroom/app/DI/FileUpload/UsersUploadDispatcher/index';
import type {
  IUsersUploadDispatcherFactory,
  IUsersUploadDispatcherFactoryMethod,
} from '@/dataroom/app/DI/FileUpload/UsersUploadDispatcher/interfaces';

export const UsersUploadDispatcherModule = new ContainerModule(({ bind }) => {
  bind<IUsersUploadDispatcherFactory>(DIUploadTypes.UsersUploadDispatcherFactory)
    .to(UsersUploadDispatcherFactory)
    .inSingletonScope();

  bind<IUsersUploadDispatcherFactoryMethod>(DIUploadTypes.UsersUploadDispatcher)
    .toFactory(({ get }) =>
      (dataroomName: string) =>
        get<IUsersUploadDispatcherFactory>(DIUploadTypes.UsersUploadDispatcherFactory)
        .create(dataroomName),
    );
});
